import { ClipLoader } from "react-spinners";
import Container from "../../components/container/Container";
import RecommendedRoomsCard from "../../components/RecommendedRoomsCard/RecommendedRoomsCard";
import useRoomCollection from "../../hooks/DatabseCollection/useRoomCollection";

const Recommended = () => {
  const { roomsData, loading } = useRoomCollection();
  return (
    <section className="mt-10 pb-20 sm:pb-10 px-3">
      <Container>
        {loading ? (
          <div className="flex justify-center mt-10">
            <ClipLoader color="black" loading={loading} size={70} />
          </div>
        ) : (
          <>
            <div className="py-5">
              <h1 className="text-lg font-semibold">Recommended Rooms</h1>
            </div>
            <div className="space-y-5">
              {roomsData.map(
                ({
                  id,
                  data: {
                    createdUser,
                    createdUserEmail,
                    createdUserId,
                    language,
                    privacyMode,
                    roomName,
                  },
                }) => (
                  <RecommendedRoomsCard
                    key={id}
                    id={id}
                    createdUser={createdUser}
                    roomName={roomName}
                    privacyMode={privacyMode}
                    createdUserId={createdUserId}
                    createdUserEmail={createdUserEmail}
                    language={language}
                  />
                )
              )}
            </div>
          </>
        )}
      </Container>
    </section>
  );
};

export default Recommended;
